import { useMemo } from 'react';
import { MDText } from 'i18n-react';
import Link from 'next/link';

import { ArrowRightIcon, GlitterIcon } from '@motorway/mw-highway-code';

import { triggerInsightsClickEvent } from 'Services/analytics/events/vehicleDetailsInsightEvents';
import { useInsightsRecentSold } from 'Utilities/hooks/recentSoldPrices/useRecentSoldPrices';
import ROUTES from 'Utilities/routes';

import { BackgroundLayout } from '../../../../BackgroundLayout/BackgroundLayout';

import { INSIGHTS_OTHER_CATEGORY, useInsightsSection } from './InsightsSection.hooks';
import insightsTexts from './InsightsSection.texts';

import styles from './InsightsSection.module.scss';

const localT = new MDText(insightsTexts);

export const InsightsSection: React.FC = () => {
	const { mainInfo, make, makeHasNoModels, model, modelName } = useInsightsSection();
	const modelId = useMemo(() => model?.id ?? 0, [model]);
	const { data: insightData } = useInsightsRecentSold({
		makeId: mainInfo.makeId,
		modelId,
	});

	const hasNoInsightData = !insightData || insightData.vehicles.length === 0;

	// we have no insights for make called 'Other'
	if (!make || hasNoInsightData || makeHasNoModels || make.name.toLowerCase() === INSIGHTS_OTHER_CATEGORY.toLowerCase())
		return null;

	const handleOnclick = () => {
		// Before model is undefined e.g no model ID what do we do for this now?
		triggerInsightsClickEvent({ makeId: make.id, modelId });
	};

	return (
		<Link
			passHref
			as={ROUTES.INSIGHTS_RESULTS.as(make.slug, modelName)}
			href={ROUTES.INSIGHTS_RESULTS.as(make.slug, modelName)}
			legacyBehavior={false}
			onClick={handleOnclick}
			target="_blank"
		>
			<BackgroundLayout backgroundColour="light" border="none" className={styles.mobileContainer}>
				<div className={styles.container}>
					<div className={styles.wrapper}>
						<h3 className={styles.heading}>
							<GlitterIcon filled size="xsmall" />
							{localT.translate('heading')}
						</h3>
						<localT.div className={styles.content} text="content" />
					</div>
					<ArrowRightIcon />
				</div>
			</BackgroundLayout>
		</Link>
	);
};
